import React, { Component } from 'react';
import Title from './Title';
import Grid from '@mui/material/Grid';
import PieChartWidget from './charts/PieChart';
import Typography from '@mui/material/Typography';

import BIMdataTable from './tables/BIMdataTable';

function preventDefault(event) {
    event.preventDefault();
}

class BIMAnalysis extends Component {
    constructor(props) {
        super(props);
        this.state = {}
    }

    render() {
        return (
            <React.Fragment>
                <Title>BIM Analysis</Title>
                <Grid container spacing={3}>
                    <Grid item xs={12} md={6} lg={6}>
                        <Typography color="text.secondary" sx={{ flex: 1 }}>
                            BIM categories
                        </Typography>
                        <PieChartWidget />
                    </Grid>

                    <Grid item xs={12} md={6} lg={6}>
                        <BIMdataTable />
                    </Grid>
                </Grid>
            </React.Fragment>
        );
    }
}

export default BIMAnalysis;
